// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kg3G5e","container__hidden":"_3VhrZsw","navigation":"_25By0Z8","navButtons":"_3r7rW4o","navButton":"_2Ac9WRp","navButton__active":"QlRTIh7","slant":"_2mZjF9Z","bold":"VukdW2l"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/LargePrimaryNavigation/index.css
// module id = ./template/components/Navigation/LargePrimaryNavigation/index.css
// module chunks = client.sitechrome